module.exports = __webpack_public_path__ + "img/builder-8.8aadf1a9.webp";